/* greys */
export var giphyBlack = '#121212';
export var giphyDarkestGrey = '#212121';
export var giphyDarkGrey = '#2e2e2e';
export var giphyDarkCharcoal = '#3e3e3e';
export var giphyCharcoal = '#4a4a4a';
export var giphyLightCharcoal = '#5c5c5c';
export var giphyLightGrey = '#a6a6a6';
export var giphyLightestGrey = '#d8d8d8';
export var giphyWhiteSmoke = '#ececec';
export var giphyWhite = '#ffffff';
/* primary */
export var giphyBlue = '#00ccff';
export var giphyGreen = '#00ff99';
export var giphyPurple = '#9933ff';
export var giphyRed = '#ff6666';
export var giphyYellow = '#fff35c';
/* secondary */
export var giphyAqua = '#00e6cc';
export var giphyLightBlue = '#3191ff';
export var giphyIndigo = '#6157ff';
export var giphyPink = '#e646b6';
/* social */
export var facebookColor = '#3894fc';
export var twitterColor = '#00ccff';
export var pinterestColor = '#e54cb5';
export var tumblrColor = '#529ecc';
export var instagramColor = '#c23c8d';
export var redditColor = '#fc6669';
export var smsColor = '#00ff99';
/* functional */
export var errorColor = giphyRed;
export var deleteColor = giphyRed;
export var primaryCTA = giphyIndigo;
export var primaryCTADisabled = '#241F74';
export var secondaryCTA = giphyCharcoal;
export var dimColor = "rgba(0, 0, 0, 0.8)";
export var gifOverlayColor = "rgba(0, 0, 0, 0.4)";
//# sourceMappingURL=colors.js.map